const regexPattern = {
  nameValidation: /^[A-Za-z]+([']?[-]?[.]?[\s]?[A-Za-z]+){0,9}$/,
  checkPassword: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).+$/,
  emailValidation:
    /^[a-zA-Z0-9_%+-]+\.?[a-zA-Z0-9_%+-]+@[a-zA-Z-]+\.[a-zA-Z]{2,}\.?[a-zA-Z]*$/,
  cityValidation: /^([A-Za-z0-9]+(?:[\s]?[A-Za-z0-9]+))+$/,
  pincodeValidation: /^(?!0)[a-zA-Z0-9]{3,32}$/,
  phoneValidation: /^[1-9]\d{9,31}$/,
  addressValidation: /^(?! ).{3,128}$/,
  replaceSpecialChar: /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/g,
  positionValidation: /^([A-Za-z]+(?:[-\s]?[A-Za-z]+))+$/,
  //legalName: /^[A-Za-z]+([']?[-]?[.]?[\s]?[A-Za-z]+){0,9}$/,
  // legalName: /^(?=.*[A-Za-z])[A-Za-z0-9 ]*$/,
  legalName: /^[A-Za-z0-9&.\-() ]+$/,
  departmentName: /^([A-Za-z]+(?:[-\s]?[A-Za-z]+))+$/,
  amount: /^[0-9]{0,9999999999}$/,
  days: /^[0-9]{0,9999}$/,
  invoiceNoValidation: /^(?![-\\])(?!.*[-\\]$)(?=.*\d)[A-Z0-9\\-]+$/,
  doubleSpace: /^\s{2,}/,
  numericValidation: /^\d+$/,
  priceValidation: /^\d*(\.\d{0,2})?$/,
  gstValidation:
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[A-Z0-9]{1}$/,
  warehouse: /^(?=.*[A-Za-z])[A-Za-z0-9](?:[A-Za-z0-9 .\-_']*[A-Za-z0-9])?$/ 
};
export default regexPattern;
